import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from 'react-router-dom';

import Finances from '@/pages/Finances/Finances';
import Login from '@/pages/Login/Login';
import Users from '@/pages/Users/Users';
import Classes from '@/pages/Classes/Classes';
import { Layout } from '@/components/Layout/Layout';
import { useAuth } from '@/hooks/useAuth';
import App from '@/App';
import Lessons from '@/pages/Lessons/Lessons';
import { PATHS } from './routes.types';
import Schools from '@/pages/Schools/Schools';
import Gifts from '@/pages/Gifts/Gifts';
import Company from '@/pages/Company/Company';
import B2bFinance from '@/pages/B2BFinance/Campaign';
import Quizz from '@/pages/Quizz/Quizz';
import Module from '@/pages/Lessons/module/Module';
import Epreuve from '@/pages/Epreuve/Epreuve';
import Coupons from '@/pages/Coupons/Coupons';
import { Evaluation } from '@/pages/Evaluation/Evaluation';
import { Faq } from '@/pages/Faq/Faq';
import { Tips } from '@/pages/Tips/Tips';
import { DetailsGrant } from '@/pages/Finances/DetailsGrant/DeatilsGrant';
import { ExPremium } from '@/pages/Finances/ExPremium/ExPremium';
import { BlankExam } from '@/pages/BlankExam/BlankExam';
import { SettingUpTests } from '@/pages/BlankExam/SettingUpTests/SettingUpTests';
import { ContentGenerator } from '@/pages/Lessons/ContentGenerator/ContentGenerator';
import { Establishments } from '@/pages/Establishments/Establishments';
import { Socium } from '@/pages/Socium/Socium';
import { SociumDetail } from '@/pages/Socium/SociumDetail';
import { Disciplines } from '@/pages/Disciplines/Disciplines';

const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Layout>{children}</Layout>;
};

const AppRoutes = () => {
  const router = createBrowserRouter([
    {
      path: '/login',
      element: <Login />,
    },
    {
      path: '/',
      element: (
        <PrivateRoute>
          <App />
        </PrivateRoute>
      ),
    },
    {
      path: PATHS.FINANCE,
      element: (
        <PrivateRoute>
          <Finances />
        </PrivateRoute>
      ),
    },
    {
      path: PATHS.DETAILS_GRANT,
      element: (
        <PrivateRoute>
          <DetailsGrant />
        </PrivateRoute>
      ),
    },
    {
      path: PATHS.EX_PREMIUM,
      element: (
        <PrivateRoute>
          <ExPremium />
        </PrivateRoute>
      ),
    },
    {
      path: PATHS.USERS,
      element: (
        <PrivateRoute>
          <Users />
        </PrivateRoute>
      ),
    },
    {
      path: PATHS.CLASSES,
      element: (
        <PrivateRoute>
          <Classes />
        </PrivateRoute>
      ),
    },
    {
      path: PATHS.LESSONS,
      element: (
        <PrivateRoute>
          <Lessons />
        </PrivateRoute>
      ),
    },
    {
      path: PATHS.GENERATOR,
      element: (
        <PrivateRoute>
          <ContentGenerator />
        </PrivateRoute>
      ),
    },
    {
      path: PATHS.EVALUATION,
      element: (
        <PrivateRoute>
          <Evaluation />
        </PrivateRoute>
      ),
    },
    {
      path: PATHS.MODULES,
      element: (
        <PrivateRoute>
          <Module />
        </PrivateRoute>
      ),
    },
    {
      path: PATHS.MODULE,
      element: (
        <PrivateRoute>
          <Module />
        </PrivateRoute>
      ),
    },
    {
      path: PATHS.TESTS,
      element: (
        <PrivateRoute>
          <Epreuve />
        </PrivateRoute>
      ),
    },
    {
      path: PATHS.TIPS,
      element: (
        <PrivateRoute>
          <Tips />
        </PrivateRoute>
      ),
    },
    {
      path: PATHS.LESSON_QUIZZ,
      element: (
        <PrivateRoute>
          <Quizz />
        </PrivateRoute>
      ),
    },
    {
      path: PATHS.MODULE_QUIZZ,
      element: (
        <PrivateRoute>
          <Quizz />
        </PrivateRoute>
      ),
    },
    {
      path: PATHS.SCHOOLS,
      element: (
        <PrivateRoute>
          <Schools />
        </PrivateRoute>
      ),
    },
    {
      path: PATHS.FAQ,
      element: (
        <PrivateRoute>
          <Faq />
        </PrivateRoute>
      ),
    },
    {
      path: PATHS.BLANK_EXAM,
      element: (
        <PrivateRoute>
          <BlankExam />
        </PrivateRoute>
      ),
    },
    {
      path: PATHS.SETTING_UP_TESTS,
      element: (
        <PrivateRoute>
          <SettingUpTests />
        </PrivateRoute>
      ),
    },
    {
      path: PATHS.GIFTS,
      element: (
        <PrivateRoute>
          <Gifts />
        </PrivateRoute>
      ),
    },
    {
      path: PATHS.COMPANY,
      element: (
        <PrivateRoute>
          <Company />
        </PrivateRoute>
      ),
    },
    {
      path: PATHS.OFERS,
      element: (
        <PrivateRoute>
          <Coupons />
        </PrivateRoute>
      ),
    },
    {
      path: PATHS.B2B_FINANCE,
      element: (
        <PrivateRoute>
          <B2bFinance />
        </PrivateRoute>
      ),
    },
    {
      path: PATHS.ESTABLISHMENTS,
      element: (
        <PrivateRoute>
          <Establishments />
        </PrivateRoute>
      ),
    },
    {
      path: PATHS.SOCIUM,
      element: (
        <PrivateRoute>
          <Socium />
        </PrivateRoute>
      ),
    },
    {
      path: PATHS.SOCIUM_DETAIL,
      element: (
        <PrivateRoute>
          <SociumDetail />
        </PrivateRoute>
      ),
    },
    {
      path: PATHS.DISCIPLINES,
      element: (
        <PrivateRoute>
          <Disciplines />
        </PrivateRoute>
      ),
    },
    {
      path: '*',
      element: <Navigate to="/" replace />,
    },
  ]);

  return <RouterProvider router={router} />;
};

export default AppRoutes;
